import { render, staticRenderFns } from "./AttrVideo.vue?vue&type=template&id=7da0f158&scoped=true"
import script from "./AttrVideo.vue?vue&type=script&lang=js"
export * from "./AttrVideo.vue?vue&type=script&lang=js"
import style0 from "./AttrVideo.vue?vue&type=style&index=0&id=7da0f158&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7da0f158",
  null
  
)

export default component.exports